import { render, staticRenderFns } from "./CharacterInfo.vue?vue&type=template&id=02f6719a&scoped=true&"
import script from "./CharacterInfo.vue?vue&type=script&lang=js&"
export * from "./CharacterInfo.vue?vue&type=script&lang=js&"
import style0 from "./CharacterInfo.vue?vue&type=style&index=0&id=02f6719a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f6719a",
  null
  
)

export default component.exports